/* fixed-featured-images.js  */
/* Locks featured-collection product images and keeps arrow nav intact */

document.addEventListener('DOMContentLoaded', () => {
  // 1️⃣  Grab every featured-collection section on the page
  const featuredSections = document.querySelectorAll(
    '.section-featured-collection, [data-section-type="featured-collection"]'
  );

  featuredSections.forEach(section => {
    // 2️⃣  Disable drag/scroll behaviour so only arrows navigate
    const slider = section.querySelector('.grid--peek, .slider, .flickity-enabled');
    if (slider) {
      slider.style.overflowX = 'hidden';          // stop mouse / touch drag
      slider.style.touchAction = 'none';
      slider.style.scrollSnapType = 'none';
    }

    // 3️⃣  Lock every product image to 144 × 144 px and remove responsive srcset
    const images = section.querySelectorAll('.card__media img');
    images.forEach(img => {
      img.style.width = '80px';
      img.style.height = '80px';
      img.style.maxWidth = '80px';
      img.style.maxHeight = '80px';
      img.style.objectFit = 'contain';

      // Remove Shopify’s responsive attributes so the theme can’t resize later
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    });

    // 4️⃣  Keep each card the same width so titles stay aligned
    const cards = section.querySelectorAll('.card-wrapper');
    cards.forEach(card => {
      card.style.width  = '80px';
      card.style.marginRight = '20px';
      card.style.flex   = '0 0 auto';
      card.style.display = 'flex';
      card.style.flexDirection = 'column';
      card.style.alignItems = 'center';
    });
  });
});
